<template>
  <Modal id="paidModal" data-bs-backdrop="static">
    <template #header>
      <h5 class="modal-title">{{ paymentModalData['with_paid'] ? $t('key_modal_paid_refunded'): $t('key_modal_paid_not_refunded') }}</h5>
    </template>
    <template #body>
      <div v-if="paymentModalData['with_paid']" class="row">
        <p>
          {{ $t('key_modalPaid_markAsNotRefunded') }}
        </p>
      </div>
      <div v-else>
        <form ref="formDate" class="px-4 py-3 .needs-validation" >
          <p>
            {{ $t('key_modalPaid_markAsRefunded') }}
          </p>
          <div class="col">
            <label class="form-label">{{ $t('key_modalPaid_refundDate' )}} <span style="color:red">*</span> </label>
            <input v-model="depositDate" class="form-control" type="date" required/>
          </div>
        </form>
      </div>
    </template>
    <template #footer>
      <button ref="closeButton" type="button" class="btn btn-outline-primary" data-bs-dismiss="modal">
        {{ $t('key_cancel') }}
      </button>
      <button type="button" class="btn bg-gradient-primary" @click="makePayment">
        {{ $t('key_confirm') }}
      </button>
    </template>
  </Modal>
</template>
  
<script>
import Modal from "@/components/ModalHotakauth.vue";
export default {
  components: { Modal },
  props: {
    paymentModalData: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['make-payment'],
  data() {
    return {
      depositDate:''
    };
  },
  computed: {
    newUsuario() {
      return this.$store.state.user.newUser.status;
    },
  },
  created() {
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.hideModal();
      }
    });
  },
  methods: {
    hideModal() {
      let button = this.$refs.closeButton;
      if (button) button.click()
    },
    makePayment() {
      let  paid;
      if (this.paymentModalData.with_paid){
        paid= false;
        this.depositDate='';
      }
      else{
        paid= true
        let form = this.$refs.formDate;
        if(!form.checkValidity() ){
          form.classList.add('was-validated')
          return
        }
      }
      this.$emit('make-payment', { entityId: this.paymentModalData._id, with_paid: paid, paid_date: this.depositDate})
      this.hideModal()
    },
  },
};
</script>
  
<style lang="scss" scoped>
.modal-usuarios .modal-container {
  width: 550px !important;
  height: 300px;
}
.was-validated .form-control:invalid, .form-control.is-invalid {
  background-position: right 1.3rem center !important;
}

</style>